// Single source for DS360 contact details used across the landing page.
export const contact = {
  phoneDisplay: '(201) 912-0705',
  phoneHref: 'tel:+12019120705',
  email: 'connect@ds360investment.com',
  emailHref: 'mailto:connect@ds360investment.com',
  calendlyUrl: 'https://calendly.com/ds360investment/30min',
  website: 'ds360investment.com',
  instagramUrl: 'https://www.instagram.com/ds360.investment?dlrf=MWZwYncwbm40dW1sZQ==',
};
